import { render } from "./FaceThumbsCell.vue?vue&type=template&id=65fdc332"
import script from "./FaceThumbsCell.vue?vue&type=script&lang=js"
export * from "./FaceThumbsCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__